import React from 'react'

import { Skeleton } from '@fourthwall/components'

import * as S from './styled'

export const EventsSkeleton = () => (
  <S.Container>
    <Skeleton.Shape width="100%" height={256} />
    <Skeleton.Shape width="100%" height={256} />
  </S.Container>
)
